// react
import React, { useEffect, useState } from "react";

// third-party
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

// data stubs
import theme from "../../data/theme";
import shopApi from "../../api/shop";
import { formatDate } from "../../services/utils";

function AccountPageOrderDetails(props) {
    const { orderId, locale } = props;

    const [orderDetails, setOrderDetails] = useState();

    useEffect(() => {
        if (orderId) {
            shopApi.getOrderDetails(orderId, locale).then((response) => {
                setOrderDetails(response);
            });
        }
    }, [orderId, locale]);

    return (
        <React.Fragment>
            <Helmet>
                <title>{`Order Details — ${theme.name}`}</title>
            </Helmet>

            <div className="card">
                <div className="order-header">
                    <div className="order-header__actions">
                        <Link to="/account/orders" className="btn btn-xs btn-secondary">
                            Back to list
                        </Link>
                    </div>
                    <h5 className="order-header__title">Order #{orderDetails?.id}</h5>
                    <div className="order-header__subtitle">
                        Was placed on <mark className="order-header__date">{formatDate(orderDetails?.dateOrdered)}</mark> 
                    </div>
                </div>
                <div className="card-divider" />
                <div className="card-table">
                    <div className="table-responsive-sm">
                        <table>
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody className="card-table__body card-table__body--merge-rows">
                                {orderDetails?.orderItems?.map((item) => (
                                    <tr key={item._id}>
                                        <td>
                                            {item.product.name} × {item.quantity}
                                        </td>
                                        <td>${item.quantity * item.product.price}</td>
                                    </tr>
                                ))}
                            </tbody>
                            {/* <tbody className="card-table__body card-table__body--merge-rows">
                                <tr>
                                    <th>Subtotal</th>
                                    <td>$5,877.00</td>
                                </tr>
                                <tr>
                                    <th>Store Credit</th>
                                    <td>$-20.00</td>
                                </tr>
                                <tr>
                                    <th>Shipping</th>
                                    <td>$25.00</td>
                                </tr>
                            </tbody> */}
                            <tfoot>
                                <tr>
                                    <th>Total</th>
                                    <td>${orderDetails?.totalPrice}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>

            <div className="row mt-3 no-gutters mx-n2">
                <div className=" col-12 px-2">
                    <div className="card address-card address-card--featured">
                        <div className="address-card__body">
                            <div className="address-card__badge address-card__badge--muted">Shipping Address</div>
                            <div className="address-card__row">
                                {orderDetails?.shippingAddress1}
                                <br />
                                {orderDetails?.zip}
                                <br />
                                {orderDetails?.city}
                                <br />
                                {orderDetails?.country}
                            </div>
                            <div className="address-card__row">
                                <div className="address-card__row-title">Phone Number</div>
                                <div className="address-card__row-content">{orderDetails?.phone}</div>
                            </div>
                            <div className="address-card__row">
                                <div className="address-card__row-title">Email Address</div>
                                <div className="address-card__row-content">{orderDetails?.email}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(AccountPageOrderDetails);
